module.exports = __webpack_public_path__ + "static/media/trash-wally.71690cc7.svg";